import { render, staticRenderFns } from "./OrdersShortDelivery.vue?vue&type=template&id=405d6864"
import script from "./OrdersShortDelivery.vue?vue&type=script&lang=js"
export * from "./OrdersShortDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports